import {SET_ACTIVE_BLOCK} from '../actionTypes';

export const aciveBlockDispatcher = (blockId) => {
  return {
    type: SET_ACTIVE_BLOCK,
    payload: {blockId},
  };
};
